import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TemplateTextDialogComponent } from './components/template-text-dialog/template-text-dialog.component';
import { CreateTemplateDialogComponent } from './components/create-template-dialog/create-template-dialog.component';
import { TemplateSharedService } from './services/template-shared/template-shared.service';
import { TemplateService } from './services/template/template.service';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { DsIconComponent } from '@design-system/ds-icon/component/ds-icon.component';
import { DsLoadingSpinnerComponent } from '@design-system/ds-loading-spinner/component/ds-loading-spinner.component';

@NgModule({
  declarations: [TemplateTextDialogComponent, CreateTemplateDialogComponent],
  imports: [DsIconComponent, DsLoadingSpinnerComponent, CommonModule, MatLegacyDialogModule, ReactiveFormsModule, SelectDropDownModule],
  exports: [TemplateTextDialogComponent, CreateTemplateDialogComponent],
  providers: [TemplateService, TemplateSharedService],
})
export class ServiceRequestTemplateModule {}
